// extracted by mini-css-extract-plugin
export default {"tasktype":"tasktype_tasktype__cntLv","type":"tasktype_type__vo+du","circle":"tasktype_circle__UX8nC","bgcircle":"tasktype_bgcircle__8cC+t","disable":"tasktype_disable__YOtqa"};